export const TIER_META = {
  "Award-Signal": { cls: "bg-zinc-900 text-white border-zinc-900", label: "AWARD-SIGNAL" },
  "Momentum Builder": { cls: "bg-blue-50 text-klein border-blue-200", label: "MOMENTUM" },
  "Established Operator": { cls: "bg-violet-50 text-violet-700 border-violet-200", label: "ESTABLISHED" },
  "Low Fit": { cls: "bg-zinc-100 text-zinc-500 border-zinc-200", label: "LOW FIT" },
};

export function TierBadge({ tier }) {
  const m = TIER_META[tier] || TIER_META["Low Fit"];
  return (
    <span
      data-testid="tier-badge"
      className={`inline-block border rounded-md px-1.5 py-0.5 text-[10px] font-mono uppercase tracking-wider ${m.cls}`}
    >
      {m.label}
    </span>
  );
}

export function ScoreChip({ score }) {
  const color = score >= 70 ? "text-emerald-700" : score >= 40 ? "text-zinc-700" : "text-red-600";
  return (
    <span className={`font-mono text-lg font-bold ${color}`} data-testid="fit-score">
      {score}
      <span className="text-[10px] text-zinc-400">/100</span>
    </span>
  );
}
